archive.classy.controller({
    name: 'ArchiveBinsController',
    inject: ['$scope', '$rootScope', '$http', 'BinFactory', '$location',
        '$anchorScroll', 'BinSummaryService', 'BinService', '$timeout', 'ArchiveYearsService'],
    init: function()
    {
        this.$.BinFactory = this.BinFactory;
        this.$.BinService = this.BinService;
        var applications = this.BinFactory.getApplications();
        this.$.years = [];
        this.$.year = "ALL";
        this.$.years[0] = {"App_Fin_Year": "ALL"}
        this.$.years = this.$.years.concat(this.ArchiveYearsService.get());
        this.yearChange("ALL");
        var parent = this;

        //This is a hack until further notice
        this.$timeout(function() {
            parent.yearChange("ALL");
        }, 1000)
        this.$.appFilter = '';
    },
    yearChange: function(year)
    {
        if (year == "ALL")
            year = 0;
        this.BinFactory.setAppFinYear(year, true);
        this.BinSummaryService.refresh(year);
    },
    binClick: function(bin)
    {
        if (this.BinFactory.bins[bin])
        {
            if (this.BinService.getBin() == bin)
            {
                var filters = ["taxFilter", "gradeFilter", "NRFilter", "SubCatsFilter", "accountsFilter"]
                for (var i = 0; i < filters.length; i++)
                {
                    var filter = filters[i];
                    for (let prop in this.BinService.filter[filter].values)
                        this.BinService.filter[filter].values[prop] = false;
                }
                this.BinService.updateFilter(filter);
                this.BinService.setFilter(filter, this.BinService.filter[filter]);
            }
            else
            {
                this.$location.hash('app0');
                this.$anchorScroll();
                this.BinService.setBin(bin);

                var year = this.$.year;
                if (year == "ALL")
                    year = 0;
                this.BinSummaryService.refresh(year);
            }
        }
        else {
            this.BinService.setBin(bin);
            this.BinSummaryService.refresh(year);
        }
    }
});
